export default __webpack_public_path__ + "static/media/youtube.b6816d24.svg";